/**
 * @name generate.js
 * @author Michaelangelo Jong
 */

(function GeneratorScope() {
  /**
   * Assert Error function.
   * @param  {Boolean} condition Whether or not to throw error.
   * @param  {String} message    Error message.
   */
  function assertError(condition, message) {
    if (!condition) {
      throw new Error(message);
    }
  }

  /**
   * Assert TypeError function.
   * @param  {Boolean} condition Whether or not to throw error.
   * @param  {String} message    Error message.
   */
  function assertTypeError(test, type) {
    if (typeof test !== type) {
      throw new TypeError('Expected \'' + type + '\' but instead found \'' + typeof test + '\'');
    }
  }

  /**
   * Returns the name of function 'func'.
   * @param  {Function} func Any function.
   * @return {String}        Name of 'func'.
   */
  function getFunctionName(func) {
    if (func.name !== void 0) {
      return func.name;
    }
    // Else use IE Shim
    var funcNameMatch = func.toString().match(/function\s*([^\s]*)\s*\(/);
    func.name = funcNameMatch && funcNameMatch[1] || '';
    return func.name;
  }

  /**
   * Returns true if 'obj' is an object containing only get and set functions, false otherwise.
   * @param  {Any} obj Value to be tested.
   * @return {Boolean} true or false.
   */
  function isGetSet(obj) {
    var keys, length;
    if (obj && typeof obj === 'object') {
      keys = Object.getOwnPropertyNames(obj).sort();
      length = keys.length;
      if (length === 1 && (keys[0] === 'get' && typeof obj.get === 'function' || keys[0] === 'set' && typeof obj.set === 'function') || length === 2 && keys[0] === 'get' && typeof obj.get === 'function' && keys[1] === 'set' && typeof obj.set === 'function') {
        return true;
      }
    }
    return false;
  }

  /**
   * Defines properties on 'obj'.
   * @param  {Object} obj        An object that 'properties' will be attached to.
   * @param  {Object} descriptor Optional object descriptor that will be applied to all attaching properties on 'properties'.
   * @param  {Object} properties An object who's properties will be attached to 'obj'.
   * @return {Generator}         'obj'.
   */
  function defineObjectProperties(obj, descriptor, properties) {
    var setProperties = {},
      i,
      keys,
      length,
      p = properties || descriptor,
      d = properties && descriptor;
    properties = p && typeof p === 'object' ? p : {};
    descriptor = d && typeof d === 'object' ? d : {};
    keys = Object.getOwnPropertyNames(properties);
    length = keys.length;
    for (i = 0; i < length; i++) {
      if (isGetSet(properties[keys[i]])) {
        setProperties[keys[i]] = {
          configurable: !!descriptor.configurable,
          enumerable: !!descriptor.enumerable,
          get: properties[keys[i]].get,
          set: properties[keys[i]].set
        };
      } else {
        setProperties[keys[i]] = {
          configurable: !!descriptor.configurable,
          enumerable: !!descriptor.enumerable,
          writable: !!descriptor.writable,
          value: properties[keys[i]]
        };
      }
    }
    Object.defineProperties(obj, setProperties);
    return obj;
  }
  var Creation = {
    /**
     * Defines properties on this object.
     * @param  {Object} descriptor Optional object descriptor that will be applied to all attaching properties.
     * @param  {Object} properties An object who's properties will be attached to this object.
     * @return {Object}            This object.
     */
    defineProperties: function defineProperties(descriptor, properties) {
      defineObjectProperties(this, descriptor, properties);
      return this;
    },
    /**
     * returns the prototype of `this` Creation.
     * @return {Object} Prototype of `this` Creation.
     */
    getProto: function getProto() {
      return Object.getPrototypeOf(this);
    },
    /**
     * returns the prototype of `this` super Creation.
     * @return {Object} Prototype of `this` super Creation.
     */
    getSuper: function getSuper() {
      return Object.getPrototypeOf(this.constructor.prototype);
    }
  };
  var Generation = {
    /**
     * Returns true if 'generator' was generated by this Generator.
     * @param  {Generator} generator A Generator.
     * @return {Boolean}             true or false.
     */
    isGeneration: function isGeneration(generator) {
      assertTypeError(generator, 'function');
      var _ = this;
      return _.prototype.isPrototypeOf(generator.prototype);
    },
    /**
     * Returns true if 'object' was created by this Generator.
     * @param  {Object} object An Object.
     * @return {Boolean}       true or false.
     */
    isCreation: function isCreation(object) {
      var _ = this;
      return object instanceof _;
    },
    /**
     * Generates a new generator that inherits from `this` generator.
     * @param {Generator} ParentGenerator Generator to inherit from.
     * @param {Function} create           Create method that gets called when creating a new instance of new generator.
     * @return {Generator}                New Generator that inherits from 'ParentGenerator'.
     */
    generate: function generate(construct) {
      assertTypeError(construct, 'function');
      var _ = this;
      defineObjectProperties(construct, {
        configurable: false,
        enumerable: false,
        writable: false
      }, {
        prototype: Object.create(_.prototype)
      });
      defineObjectProperties(construct, {
        configurable: false,
        enumerable: false,
        writable: false
      }, Generation);
      defineObjectProperties(construct.prototype, {
        configurable: false,
        enumerable: false,
        writable: false
      }, {
        constructor: construct,
        generator: construct
      });
      return construct;
    },
    /**
     * Defines shared properties for all objects created by this generator.
     * @param  {Object} descriptor Optional object descriptor that will be applied to all attaching properties.
     * @param  {Object} properties An object who's properties will be attached to this generator's prototype.
     * @return {Generator}         This generator.
     */
    definePrototype: function definePrototype(descriptor, properties) {
      defineObjectProperties(this.prototype, descriptor, properties);
      return this;
    }
  };
  function Generator() {}
  defineObjectProperties(Generator, {
    configurable: false,
    enumerable: false,
    writable: false
  }, {
    prototype: Generator.prototype
  });
  defineObjectProperties(Generator.prototype, {
    configurable: false,
    enumerable: false,
    writable: false
  }, Creation);
  defineObjectProperties(Generator, {
    configurable: false,
    enumerable: false,
    writable: false
  }, Generation);
  defineObjectProperties(Generator, {
    configurable: false,
    enumerable: false,
    writable: false
  }, {
    /**
     * Returns true if 'generator' was generated by this Generator.
     * @param  {Generator} generator A Generator.
     * @return {Boolean}             true or false.
     */
    isGenerator: function isGenerator(generator) {
      return this.isGeneration(generator);
    },
    /**
     * Generates a new generator that inherits from `this` generator.
     * @param {Generator} extendFrom      Constructor to inherit from.
     * @param {Function} create           Create method that gets called when creating a new instance of new generator.
     * @return {Generator}                New Generator that inherits from 'ParentGenerator'.
     */
    toGenerator: function toGenerator(extendFrom, create) {
      console.warn('Generator.toGenerator is depreciated please use Generator.generateFrom');
      return this.generateFrom(extendFrom, create);
    },
    /**
     * Generates a new generator that inherits from `this` generator.
     * @param {Constructor} extendFrom    Constructor to inherit from.
     * @param {Function} create           Create method that gets called when creating a new instance of new generator.
     * @return {Generator}                New Generator that inherits from 'ParentGenerator'.
     */
    generateFrom: function generateFrom(extendFrom, create) {
      assertTypeError(extendFrom, 'function');
      assertTypeError(create, 'function');
      defineObjectProperties(create, {
        configurable: false,
        enumerable: false,
        writable: false
      }, {
        prototype: Object.create(extendFrom.prototype)
      });
      defineObjectProperties(create, {
        configurable: false,
        enumerable: false,
        writable: false
      }, Generation);
      defineObjectProperties(create.prototype, {
        configurable: false,
        enumerable: false,
        writable: false
      }, {
        constructor: create,
        generator: create
      });
      defineObjectProperties(create.prototype, {
        configurable: false,
        enumerable: false,
        writable: false
      }, Creation);
      return create;
    }
  });
  Object.freeze(Generator);
  Object.freeze(Generator.prototype);

  // Exports
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(function () {
      return Generator;
    });
  } else if (typeof module === 'object' && typeof exports === 'object') {
    // Node/CommonJS
    module.exports = Generator;
  } else {
    // Browser global
    window.Generator = Generator;
  }
})();